import { FC, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../redux/types/types'
import * as yup from 'yup'
import { Formik, FormikValues } from 'formik'
import styles from './AboutUserComponent.module.css'
import iconEdit from '../../assets/icons/iconEdit.svg'
import CustomInput from '../UI/CustomInput/CustomInput'
import InputMask from 'react-input-mask'
import s from '../../styles/common/Form.module.css'
import p from '../UI/CustomInput/CustomInput.module.css'
import { ItemInfo } from '../ItemInfo/ItemInfo'
import { changeCurrentStaffMainInformation, getCurrentStaff } from '../../redux/actions/staffAction'
import { getMe } from '../../redux/actions/meAction'
import CustomButton from '../UI/CustomButton/CustomButton'
import { useToast } from '../../context/ToastContext'

export type AboutMeComponentPropsType = {
  isMe?: boolean
  userId: number
  fullName: string
  phone: string
  companyName: string
}

const AboutUserComponent: FC<AboutMeComponentPropsType> = ({
  isMe,
  userId,
  phone,
  fullName,
  companyName,
}) => {
  const [editMode, setEditMode] = useState(false)
  const { showSuccess, showError } = useToast()
  const { userRole, token } = useAppSelector((state) => state.auth)

  const dispatch = useAppDispatch()

  const validationSchema = yup.object().shape({
    fullName: yup.string().required('Поле является обязательным'),
    phone: yup.string().required('Поле является обязательным'),
  })

  const handleSubmitHandler = async (values: FormikValues) => {
    const mobileWithoutSymbols = `+${values.phone.replace(/[\D]+/g, '')}`

    const resultAction = await dispatch(
      changeCurrentStaffMainInformation({
        token,
        staffId: String(userId),
        phone: mobileWithoutSymbols,
        fullName: values.fullName,
      }),
    )

    if (changeCurrentStaffMainInformation.rejected.match(resultAction)) {
      showError('Произошла ошибка при изменении данных.')
    } else {
      showSuccess('Данные успешно изменены')
      setEditMode(false)
      isMe
        ? await dispatch(getMe({ token }))
        : dispatch(getCurrentStaff({ staffId: String(userId), token }))
    }
  }

  return (
    <div className={styles.aboutMe}>
      {editMode ? (
        <div className={styles.editMode}>
          <Formik
            initialValues={{
              fullName: fullName ? fullName : '',
              phone: phone ? phone : '',
              companyName: companyName ? companyName : '',
            }}
            validateOnBlur
            onSubmit={(values) => handleSubmitHandler(values)}
            validationSchema={validationSchema}
          >
            {(props) => {
              const { values, touched, errors, isValid, handleChange, handleBlur, handleSubmit } =
                props

              return (
                <>
                  <div className={styles.header}>
                    <h2 className={styles.title}>Личные данные</h2>
                    <div className={styles.btnGroup}>
                      <CustomButton
                        className={styles.cancelBtn}
                        title={'Отменить'}
                        onClick={() => setEditMode(false)}
                      />
                      <CustomButton
                        className={styles.submitBtn}
                        title={'Сохранить'}
                        onClick={() => handleSubmitHandler(values)}
                      />
                    </div>
                  </div>

                  <div className={styles.container}>
                    <div className={styles.fullNameBlock}>
                      <div className={styles.leftBlock}>ФИО</div>
                      <div className={styles.rightBlock}>
                        <CustomInput
                          type='text'
                          placeholder=''
                          name='fullName'
                          required
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.fullName}
                          className={
                            errors.fullName && touched.fullName
                              ? `${styles.inputError} ${styles.input}`
                              : styles.input
                          }
                        />
                      </div>
                    </div>
                    <div className={styles.phoneBlock}>
                      <div className={styles.leftBlock}>Номер телефона</div>
                      <div className={styles.rightBlock}>
                        <InputMask
                          mask='+7 (999) 999 9999'
                          type='phone'
                          placeholder=''
                          name='phone'
                          required
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.phone}
                          className={
                            errors.phone && touched.phone
                              ? `${s.inputError} ${p.input} ${styles.input}`
                              : `${p.input} ${styles.input}`
                          }
                        ></InputMask>
                      </div>
                    </div>
                    <div className={styles.fullNameBlock}>
                      <div className={styles.leftBlock}>Компания</div>
                      <div className={styles.rightBlock}>
                        <div className={styles.companyBlock}>{values.companyName}</div>
                      </div>
                    </div>
                  </div>
                </>
              )
            }}
          </Formik>
        </div>
      ) : (
        <div className={styles.staticInformation}>
          <div className={styles.header}>
            <h2 className={styles.title}>Личные данные</h2>
            {userRole !== 'employeePlace' && userRole !== 'employeeAgent' && (
              <div className={styles.editIconBlock}>
                <CustomButton
                  iconSrc={iconEdit}
                  className={styles.editBtn}
                  title={''}
                  onClick={() => setEditMode(true)}
                />
              </div>
            )}
          </div>
          <div className={styles.container}>
            <ItemInfo title='ФИО' value={fullName} />
            <ItemInfo title='Номер телефона' value={phone} />
            <ItemInfo title='Компания' value={companyName} />
          </div>
        </div>
      )}
    </div>
  )
}

export default AboutUserComponent
